import { ShipmentRuleBlockingCauseResponse } from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-rule-blocking-cause/shipment-rule-blocking-cause.dto'
import {
    initialShipmentRulesModalBasicDataState,
    ShipmentRulesModalBasicDataState
} from '@/modules/configurationModule/detail/shipments/shipment-rules/components/shipment-rules-modal-basic-form/shipment-rules-modal-basic-form.model'
import { EnumResponse } from '@/api/services/common.dto'
import { ShipmentRuleAssayResponse } from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-rule-assay/shipment-rule-assay.dto'
import { CommonAssayResponse } from '@/api/services/common/assay/common-assay.dto'
import { CommonStatusResponse } from '@/api/services/common/status/common-status.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { Nullable } from '@/shared/types/app.types'

export interface ShipmentRulesModalState {
    tabIndex: number,
    basicData: ShipmentRulesModalBasicDataState,
    blockingCauses: ShipmentRuleBlockingCauseResponse[],
    shipmentRulesAssayPaginatorResponse: Nullable<IResponseAgGrid<ShipmentRuleAssayResponse>>,
    comboOptions: {
        shipmentRulesBlockingCauses: EnumResponse[],
        assays: CommonAssayResponse[],
        assayStates: CommonStatusResponse[]
    }
}
export const initialShipmentRulesModalState =
    (): ShipmentRulesModalState => ({
        tabIndex: 0,
        basicData: initialShipmentRulesModalBasicDataState(),
        blockingCauses: [],
        shipmentRulesAssayPaginatorResponse: null,
        comboOptions: {
            shipmentRulesBlockingCauses: [],
            assays: [],
            assayStates: []
        }
    })
